import React, { Component } from "react";
import { Link } from "react-router-dom";

import ImageUploader from "react-images-upload";
import ImagesUploader from "react-images-uploader";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class AddEvent extends Component {
  state = {
    startDate: new Date()
  };
  handleDayTime = date => {
    this.setState({
      startDate: date
    });
  };
  render() {
    return (
      <div className="pt-3">
        <div className="container border shadow-sm p-0 bg-white">
          <div className="header bg-primary text-white">
            <div className="row m-0">
              <div className="col-md-6 p-3 d-flex align-items-center">
                <h5 className="m-0">
                  <Link to="/admin/dashboard">Home</Link> /{" "}
                  <Link to="/Calendar">Calendar</Link> / <b> Add Event</b>
                </h5>
              </div>
              <div className="col-md-6 d-flex justify-content-end align-items-center">
                {/* <div className="btn btn-dark float-right">Add Course</div> */}
              </div>
            </div>
          </div>

          <div className="row m-0 mt-3">
            <div className="col-md-6">
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Event Name
                </label>
                <input
                  type="text"
                  class="form-control col-8"
                  placeholder="Event Name"
                  id="inputDefault"
                />
              </div>

              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Discription
                </label>
                <textarea
                  type="text"
                  class="form-control col-8"
                  placeholder="Enter Discription"
                  id="inputDefault"
                />
              </div>

              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Select Date
                </label>
                {/* Select Day */}
                <div className="card border card-selector mini  d-flex flex-row day-picker">
                  <i class="far fa-calendar-alt" />
                  <DatePicker
                    selected={this.state.startDate}
                    onChange={this.handleDayTime}
                    dateFormat="MMMM d, yyyy"
                  />
                </div>
              </div>
              
              <div class="form-group row">
                <label
                  class="col-form-label col-4 text-right"
                  for="inputDefault"
                >
                  Select Time
                </label>
                {/* Select Day */}
                <div className="card border card-selector mini  d-flex flex-row day-picker">
                <i class="far fa-clock" />
                  <DatePicker
                    selected={this.state.startDate}
                    onChange={this.handleDayTime}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    dateFormat="h:mm aa"
                    timeCaption="Time"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="p-3 m-0 border-top">
            <div className="btn btn-primary"> Save</div> or{" "}
            <a className="btn-link">Cancel</a>
          </div>
        </div>
      </div>
    );
  }
}
